import common_messages_en from './en/common_messages.mjs';
import mock_messages_en from './en/mock_messages.mjs';

const getDialogueMessages = ( includeMockMessages ) => {
    const en = includeMockMessages
        ? {...mock_messages_en, ...common_messages_en }
        : { ...common_messages_en };
    return { en };
};

export {
    common_messages_en,
    mock_messages_en,
    getDialogueMessages
};
